import { userConstants } from '../constants/actionTypes'

const isSpecialEmployer = (employer, parentOrganisationERCode) => {
  if (!employer) return null

  //Rio Tinto
  const rioCodes = ['RIOT', 'RTTRPL', 'PAC', 'RTTRP', 'RTIO']
  const nswHNCodes = ['CHCS']
  if (rioCodes.indexOf(employer.employerGRS.contractGroupEmployerCode) !== -1) {
    return 'RIO'
  }

  if (parentOrganisationERCode === 'RIOT') {
    if (
      employer.name.startsWith('DSL') ||
      employer.name.startsWith('RTS') ||
      employer.name.startsWith('ERA')
    )
      return 'RIO'
  } else if (
    parentOrganisationERCode &&
    parentOrganisationERCode.toLowerCase() === 'sag'
  ) {
    // SA Government employer code - sag
    return 'SAG'
  } else if (
    (parentOrganisationERCode &&
      parentOrganisationERCode.toLowerCase() === 'nswhn') ||
    nswHNCodes.indexOf(employer.employerGRS.contractGroupEmployerCode) !== -1
  ) {
    // NSW Health Network employer code - NSWHN
    return 'NSWHN'
  }
  
  // Victoria Police
  if (employer.employerGRS.contractGroupEmployerCode === 'VICPO') return 'VICPO'

  // ACT
  if (employer.employerGRS.contractGroupEmployerCode === 'ACTGO') return 'ACTGO'

  // Qantas
  if (parentOrganisationERCode === 'QFGRP') return 'QAN'

  // RemServ Energy Queensland
  if (employer.employerGRS.contractGroupEmployerCode ==='REMEQ') return 'REMEQ'

  return null
}

const initialState = {
  isFetching: false,
  hasSpartaVehicle: false,
  applicationMaintenanceStatus: {
    isApplicationOnMaintenance: false,
    maintenanceTitle: '',
    maintenanceMessage: '',
  },
  specialEmployerCode: null,
  isAtSettlement: false,
}

export function user(state = initialState, action) {
  switch (action.type) {
    case userConstants.FETCH_USER_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case userConstants.FETCH_USER_SUCCESS:
      var customer = action.user.customer  
      if (customer && customer.employer)
        customer.employer.specialEmployerCode = isSpecialEmployer(
            action.user.customer.employer || null,
            action.user.parentOrganisationERCode
        )

      if (global.config.brand === 'Maxxia') {
        return {
          ...customer,
          isFetching: false,
          hasSpartaVehicle: action.user.hasSpartaVehicle,
          applicationMaintenanceStatus:
            action.user.applicationMaintenanceStatus,
          isAtSettlement: action.user.isAtSettlement
            ? action.user.isAtSettlement
            : state.isAtSettlement,
        }
      } else if (global.config.brand === 'RemServ') {
          return {
            ...customer,
            isFetching: false,
            hasSpartaVehicle: action.user.hasSpartaVehicle,
            applicationMaintenanceStatus:
              action.user.applicationMaintenanceStatus,
            isAtSettlement: action.user.isAtSettlement
              ? action.user.isAtSettlement
              : state.isAtSettlement,
            isGov: action.user.parentOrganisationERCode === 'QLDGOVT',
          }
        }
      break;
    case userConstants.FETCH_USER_ERROR:
      return {
        isFetching: false,
        opportunityId: state.opportunityId,
        errorMessage: action.errorMessage,
      }
    default:
      return state
  }
}
